import React, { useState } from 'react'
import { Popover, Tooltip } from 'antd'
import { ReactComponent as NoteIcon } from '../../assets/icons/edit.svg'
import Button from '../Button/Button'
import InputTextArea from '../InputTextArea/InputTextArea'

const NotePopover = ({ notes, onSave }) => {
  const [editedNotes, setEditedNotes] = useState(notes)
  const [open, setOpen] = useState(false)

  const handleNotesChange = (e) => {
    setEditedNotes(e.target.value)
  }
  const handleOpenChange = (isOpen) => {
    setOpen(isOpen)
    if (!isOpen) {
      // Save the edited notes when the popover is closed
      onSave(editedNotes)
    }
  }

  const title = <p>Note</p>

  return (
    <Popover
      content={
        <div className="textarea-container">
          <InputTextArea
            existingValue={editedNotes}
            onChange={handleNotesChange}
          />
          <div>
            <Button
              danger
              label={'Cancel'}
              onClick={() => {
                setOpen(false)
              }}
            />
            <Button
              type="primary"
              label={'Save'}
              onClick={() => {
                setOpen(false)
                onSave(editedNotes)
              }}
            />
          </div>
        </div>
      }
      placement="bottomRight"
      title={title}
      trigger="click"
      open={open}
      onOpenChange={handleOpenChange}
    >
      <Tooltip title="Add Note" placement="top">
        <Button
          type="link"
          className="add-package"
          aria-label="Add or edit timesheet row note"
          icon={
            <NoteIcon
              width={22}
              height={22}
              color={'#ef5366'}
              aria-hidden="true"
            />
          }
        />
      </Tooltip>
    </Popover>
  )
}

export default NotePopover
